import CookieManager from '@react-native-cookies/cookies';

import configs from '@webtrader/core/configs';
import { TLang } from '@webtrader/core/i18n';

export enum ENativeCookieName {
  LANG = 'lang'
}

export type NativeCookieKeyValueList = {
  [ENativeCookieName.LANG]: TLang;
};

const setValue = async <CookieName extends keyof NativeCookieKeyValueList>(
  name: CookieName,
  value: NativeCookieKeyValueList[CookieName]
) => {
  CookieManager.set(
    configs.baseURL,
    {
      name,
      path: '/',
      value
    },
    true
  );
};

const getValue = async <CookieName extends keyof NativeCookieKeyValueList>(name: CookieName) => {
  const cookies = await CookieManager.get(configs.baseURL, true);

  return cookies[name]?.value as NativeCookieKeyValueList[CookieName] | undefined;
};

export default { setValue, getValue };
